import { useEffect, useState } from 'react';
import usePage from './use-page';
import {
  ActivityTypes,
  FindTheObjectInterface,
  FindTheLetterInterface,
} from '../providers/GameProvider/types';
import { PageViewType } from '../types';

const usePagingActivity = (
  currentActivityData: FindTheObjectInterface[] | FindTheLetterInterface[],
  activityData: any,
  activityType: any
): { onePageBehavior: boolean; hasSecondPage: boolean } => {
  const [onePageBehavior, setOnePageBehaviour] = useState(false);
  const [hasSecondPage, setHasSecondPage] = useState(true);
  const [, { setNumberOfPagesDisplayed }] = usePage();

  const areTheSameSVGForBothPages = (findTheObjectsData: FindTheObjectInterface[]) =>
    !!findTheObjectsData[0].svg &&
    !!findTheObjectsData[1].svg &&
    findTheObjectsData[0].svg.src === findTheObjectsData[1].svg.src;

  const computeOnePageBehaviour = (currentActivityData) => {
    if (activityType === ActivityTypes.FIND_THE_LETTER) {
      const findTheLetterData: FindTheLetterInterface[] = currentActivityData;
      return setOnePageBehaviour(!findTheLetterData?.[1] || !findTheLetterData?.[1]?.png);
    }

    if (activityType === ActivityTypes.FIND_THE_OBJECTS) {
      const findTheObjectsData: FindTheObjectInterface[] = currentActivityData;
      return setOnePageBehaviour(
        !findTheObjectsData?.[1]?.svg || areTheSameSVGForBothPages(findTheObjectsData)
      );
    }

    return setOnePageBehaviour(false);
  };

  useEffect(() => {
    // TODO: FindTheObjects will have always have 2pg layout
    setNumberOfPagesDisplayed(PageViewType.TwoPage);
  }, [activityData]);

  useEffect(() => {
    if (!currentActivityData) {
      return;
    }
    computeOnePageBehaviour(currentActivityData);
    setHasSecondPage(!!currentActivityData[1]);
  }, [currentActivityData]);

  return {
    onePageBehavior,
    hasSecondPage,
  };
};

export default usePagingActivity;
